// import "../TherapistList/TherapistsList.scss";
import "../MedHelpList/MedHelpList.scss";
import React, { useState } from "react";

function TherapistList({ allTherapists }) {
  const [search, setSearch] = useState("");
  const [searchType, setSearchType] = useState("location"); // default: province/location

  if (!allTherapists) {
    return <p>Loading...</p>;
  }

  // Filter logic based on dropdown choice
  const filteredTherapists = allTherapists.filter((item) => {
    if (!search) return true; // no search term = show all
    const term = search.toLowerCase();

    if (searchType === "location") {
      return item.location.toLowerCase().includes(term);
    }

    if (searchType === "name") {
      return item.name.toLowerCase().includes(term);
    }

    if (searchType === "title") {
      return item.title.toLowerCase().includes(term);
    }

    if (searchType === "status") {
      return item.status.toLowerCase().includes(term);
    }

    return true;
  });

  return (
    <div className="resources">
      <h1 className="resources__title">Grief Therapists</h1>
      <form className="resources__form" onSubmit={(e) => e.preventDefault()}>
        {/* Dropdown to select search type */}

        <div className="resources__search-wrapper">
          <select
            className="resources__dropdown"
            value={searchType}
            onChange={(e) => setSearchType(e.target.value)}
          >
            <option value="location">Location</option>
            <option value="name">Name</option>
            <option value="title">Title</option>
            <option value="status">Status</option>
          </select>

          {/* Search input */}
          <input
            className="resources__search"
            name="search"
            id="search"
            type="text"
            placeholder={`Search by ${searchType}...`}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
      </form>
      {/* Render filtered resources */}
      {filteredTherapists.map((item) => (
        <div key={item.id} className="resources-cards">
          <div className="resources-cards__container">
            <div className="resources-cards__top">
              <h2 className="resources-cards__name">{item.name}</h2>
              <h3 className="resources-cards__title">{item.title}</h3>

              <p className="resources-cards__address">{item.status}</p>
              <p className="resources-cards__address">{item.location}</p>
              <p className="resources-cards__address">{item.phone}</p>
            </div>

            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="resources-cards__description"
            >
              Find Out More
            </a>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TherapistList;
